<template>
    <div>
        <el-carousel :height="computeHeight">
            <el-carousel-item v-for="(item, index) in sliders" :key="index">
                <el-image
                    class="slider_img"
                    :src="item.img"
                    fit="cover"></el-image>
            </el-carousel-item>
        </el-carousel>
        <!-- 公司简介 -->
        <div class="company_intro_root">
            <div class="company_intro_container">
                <el-row :gutter="20">
                    <el-col :xs="24" :sm="16">
                        <div class="container_v">
                            <div class="container_h align_center">
                                <div class="module_title">公司简介</div>
                                <div class="v_divider"></div>
                                <div class="module_title_c">COMPANY PROFILE</div>
                            </div>
                            <div class="module_title_s"></div>
                            <div class="v_company_intro_content">
                                {{value_company_intro}}
                            </div>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <div class="container_h container_h_r align_center">
                            <img :src="img_thumb_company_intro" style="width: 80%;height: auto;border: 0;"/>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <!-- 短信业务介绍 -->
        <div class="company_sms_root">
            <div class="company_sms_container">
                <div class="container_v">
                    <div class="container_h align_center">
                        <div class="module_title">短信业务介绍</div>
                        <div class="v_divider"></div>
                        <div class="module_title_c">SMS SERVICE INTRODUCTION</div>
                    </div>
                    <div class="module_title_s"></div>
                    <div class="v_sms_intro_content">
                        {{value_sms_intro}}
                    </div>
                    <el-row :gutter="20">
                        <el-col v-for="item in module_sms" style="margin-top: 40px;" v-bind:key="item.img" :xs="24" :sm="12" :md="6">
                            <div class="sms_module">
                                <div class="sms_module_thumb">
                                    <div class="sms_module_img">
                                        <img :src="item.img" style="width: 100%;height: auto;border: 0;">
                                    </div>
                                    <div class="sms_module_title">
                                        <div class="title">{{item.title}}</div>
                                        <div class="secondTitle">{{item.secondTitle}}</div>
                                    </div>
                                </div>
                                <div class="sms_module_content">{{item.content}}</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <!-- 外呼系统介绍 -->
        <div class="company_intro_root" style="padding-bottom: 80px;">
            <div class="company_intro_container">
                <div class="container_v">
                    <div class="container_h align_center">
                        <div class="module_title">外呼系统介绍</div>
                        <div class="v_divider"></div>
                        <div class="module_title_c">OUTGOING CALL SYSTEM</div>
                    </div>
                    <div class="module_title_s"></div>
                    <div class="v_company_intro_content">
                        我们的外呼系统能够为企业客户提供“<span style="color: #1C5DDD;">业务、营销、服务</span>”三大核心运营流程的客户联络场景。客户通过接入SUPER TECH的智能客户联络平台，即可使用呼叫中心、在线客服、工单系统、企微助手、文本机器人、外呼机器人、智能质检、PaaS云通信、通信中台等产品和服务，并可无缝地与客户自有业务系统打通。全业务都在一套平台上运行，流程高度协同、数据完全统一，极大地提升企业的运行效率、优化客户体验、降低运营成本。
                    </div>
                    <div>
                        <el-row :gutter="20">
                            <el-col v-for="item in module_outcall" style="margin-top: 40px;" v-bind:key="item.img" :xs="24" :sm="24" :md="8">
                                <div class="outcall_module">
                                    <div class="outcall_module_img">
                                        <img :src="item.img" style="width: 40px;height: 40px;border: 0;">
                                        <div class="title">{{item.title}}</div>
                                    </div>
                                    <div class="outcall_module_content">{{item.content}}</div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Index',
        data() {
            return {
                url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
                sliders: [],
                img_thumb_company_intro: require('../../static/index/img_index_thumb_company_intro.jpg'),
                value_company_intro: '我们是一家专业从事商务短信和语音业务的通信企业，我们拥有多年的移动通信技术研发经验，并致力于短信和语音应用技术的开发、产品销售和系统集成，为广大客户提供全方位的短信和语音应用解决方案。',
                value_sms_intro: '为大中小型企业及金融客户提供基于中国移动、中国电信、中国联通、国际运营商的提醒、沟通、通知、催告、营销等短信服务。包括以下服务：',
                module_sms: [
                    {
                        img: require('../../static/index/img_index_thumb_sms_intro_1.jpg'),
                        title: '短信验证码',
                        secondTitle: '极速验证 5秒必达',
                        content: '语音、文字验证码，适用于用户注册、登录验证、找回密码、支付认证等'
                    },
                    {
                        img: require('../../static/index/img_index_thumb_sms_intro_2.jpg'),
                        title: '营销短信',
                        secondTitle: '精准营销 筛选目标客户',
                        content: '会员服务、节日促销、业务推广、展会、招聘会邀请'
                    },
                    {
                        img: require('../../static/index/img_index_thumb_sms_intro_3.jpg'),
                        title: '短信通知',
                        secondTitle: '运营商资源储备',
                        content: '节日祝福、会议通知、物流通知、系统通知、预警通知等'
                    },
                    {
                        img: require('../../static/index/img_index_thumb_sms_intro_4.jpg'),
                        title: '接口短信',
                        secondTitle: '数据加密、信息安全',
                        content: '网站、app及系统软件通过接入短信网接口，实现短信触发'
                    }
                ],
                module_outcall: [
                    {
                        img: require('../../static/index/icon_index_thumb_outcall_intro_1.png'),
                        title: '接入灵活',
                        content: '我们的语音线路支持PSTN和VoIP两种线路方式，具有稳定的通信质量、安全的通信保障的特点。'
                    },
                    {
                        img: require('../../static/index/icon_index_thumb_outcall_intro_2.png'),
                        title: '系统全面',
                        content: '我们的外呼系统可以通过SAAS方式在线使用，也支持用户独立部署，满足客户的个性化需求。'
                    },
                    {
                        img: require('../../static/index/icon_index_thumb_outcall_intro_3.png'),
                        title: '智能服务',
                        content: '公司基于多年运营经验结合人工智能技术，为客户提供智能化的外呼服务和质检服务，能够实现精准外呼、机器人坐席和智能质检等应用场景。'
                    }
                ],
                carousel_height: '450px',
            }
        },
        created() {
            sessionStorage.setItem('language', 'ch');
        },
        methods: {},
        mounted() {
            this.sliders = [
                {
                    img: require("../../static/index/banner01.jpg")
                }
            ]
        },
        computed: {
            //计算高度
            computeHeight() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 415) {
                    return '450px';
                } else {
                    return '250px';
                }
            },
            computeArrowImg() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 450) {
                    return require('../../static/other/arrow.png');
                } else {
                    return require('../../static/other/arrow_down.png');
                }
            }
        },
    }
</script>

<style scoped>

    .container_v {
        display: flex;
        flex-direction: column;
    }
    .container_h {
        display: flex;
        flex-direction: row;
    }
    .container_h_r {
        display: flex;
        flex-direction: row-reverse;
    }
    .justify_center {
        justify-content: center;
    }
    .align_center {
        align-items: center;
    }
    .module_title {
        color: #000000;
        font-size: 1.45em;
        font-weight: bold;
        letter-spacing: 3px;
    }
    .module_title_c {
        color: #1C5DDD;
        font-size: 0.85em;
        font-weight: bold;
        letter-spacing: 3px;
    }
    .v_divider {
        background-color: #1C5DDD;
        width: 2px;
        height: 15px;
        margin-left: 10px;
        margin-right: 10px;
    }
    .module_title_s {
        background-color: #1C5DDD;
        width: 90px;
        height: 7px;
        margin-top: 10px;
    }

    .company_intro_root {
        width: 100%;
        background-color: white;
    }
    .company_intro_container {
        width: 70%;
        margin: auto;
        padding-top: 60px;
        padding-bottom: 60px;
    }
    .v_company_intro_content {
        margin-top: 40px;
        font-size: 16px;
        text-indent: 32px;
        color: #0E1228;
        line-height: 32px;
    }

    .company_sms_root {
        width: 100%;
        background-color: #F6F6F6;
    }
    .company_sms_container {
        width: 70%;
        margin: auto;
        padding-top: 60px;
        padding-bottom: 60px;
    }
    .v_sms_intro_content {
        margin-top: 40px;
        font-size: 16px;
        text-indent: 32px;
        color: #0E1228;
        line-height: 32px;
    }

    .sms_module {
        width: 100%;
        background-color: white;
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        height: auto;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
    }
    .sms_module_thumb {
        display: flex;
        flex-direction: column;
        position: relative;
    }
    .sms_module_title {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        transform: translate(-50%, -50%);
        color: white;
        text-align: center;
    }
    .sms_module_title .title {
        font-size: 32px;
        letter-spacing: 1px;
    }
    .sms_module_title .secondTitle {
        font-size: 18px;
        letter-spacing: 1px;
        margin-top: 20px;
    }
    .sms_module_content {
        min-height: 130px;
        margin-top: 10px;
        font-size: 16px;
        text-indent: 32px;
        letter-spacing: 5px;
        line-height: 30px;
        padding: 20px;
    }

    .outcall_module {
        width: 100%;
        background-color: white;
        border-radius: 6px;
        border: 1px solid #0000003a;
        height: auto;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .outcall_module .outcall_module_img {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 30px;
    }
    .outcall_module .outcall_module_img .title {
        font-size: 20px;
        letter-spacing: 1px;
        color: #0E1228;
        font-weight: bold;
        margin-left: 10px;
    }
    .outcall_module_content {
        min-height: 200px;
        margin-top: 10px;
        font-size: 16px;
        text-indent: 32px;
        letter-spacing: 5px;
        line-height: 30px;
        padding: 20px;
    }

    .slider_img {
        height: 450px;
        width: 100%;
    }

    /* 屏幕设备适配 max-device-width: 400px */
    @media screen and (max-device-width: 415px) {
        .slider_img {
            height: 250px;
            width: 100%;
        }
    }
</style>